export class GChartTooltipAxisPointer {
  type?: 'cross' | 'line' = 'line';

  constructor(init: Readonly<GChartTooltipAxisPointer>) {
    Object.assign(this, init);
  }
}


